import http from './http_client';

export async function fetchCountries() {
  const response = await http.get(`${http.apiUrl()}/settings/countries`);
  return response.data || [];
}

export async function fetchCountryName(code) {
  if (!code) {
    return null;
  }

  const response = await http.get(`${http.apiUrl()}/settings/countries/${code}`);
  return response.data?.name || null;
}
